export default function() {
  return {
    responseDashboad: []
  }
}
